<template id="articleList"  >
  <div
    id="articless"
    class="container"
    v-loading="floading"
    element-loading-background="transparent"
  >
    <section>
      <div class="row">
        <div class="col-lg-9 pr-lg-4">
          <!-- 文章分類 -->
          <div class="article-category-selector section-group">
            <h2 class="section-title">{{ $t('Topic.articlelist.msg') }}</h2>
            <div class="section-sub">
              <div class="category">
                <el-button
                  size="mini"
                  :class="{ current: 0 == topicTypeId }"
                  @click="GetListByType(0)"
                  >{{ $t('Topic.articlelist.all') }}</el-button
                >
                <el-button
                  size="mini"
                  v-for="item in topicTypeList"
                  :key="item.id"
                  :class="{ current: item.id == topicTypeId }"
                  @click="GetListByType(item.id)"
                  >{{ item.sgL_NewName }}</el-button
                >
              </div>
            </div>
          </div>
          <!-- /.文章分類 -->
          <!-- 文章列表 -->
          <div class="article-list section-group">
            <div class="row">
              <div
                class="col-12 col-sm-6 col-lg-4"
                v-for="topic in topicList"
                v-bind:key="topic.id"
              >
                <div class="article-card card">
                  <router-link
                    v-bind:to="{
                      name: 'articleview',
                      query: {
                        id: topic.id,
                      },
                    }"
                    @click.native="go"
                  >
                    <div class="article-block">
                      <div class="article-thumbnail">
                        <div class="article-responsive">
                          <div class="article-sizer">
                            <div
                              class="article-image"
                              :style="{
                                backgroundImage:
                                  'url(' + `${topic.sgL_ImageUrl}` + ')',
                              }"
                            ></div>
                            <!-- <div
                              class="article-image"
                              :style="{
                                backgroundImage:
                                  'url(' +
                                  require('../../assets/images/topic/article-1/article-1-2.jpg') +
                                  ')',
                              }"
                            ></div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="article-info p-3">
                      <div class="article-title mb-2" :title="topic.sgL_Title">
                        {{ topic.sgL_Title }}
                      </div>
                      <span class="article-category">{{
                        topic.sgL_MasterSortF
                      }}</span>
                      <span class="article-upload-date">{{
                        topic.sgL_CreateTimeE
                      }}</span>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
            <!-- 頁碼 -->
            <div class="row my-5">
              <div class="col-12">
                <!--  引用分页组件 -->
                <pagination
                  v-if="getPageShow"
                  :currentPage="pageParams.currentPage"
                  :total="pageParams.total"
                  :limit="pageParams.limit"
                  :small="true"
                  @handleCurrentChange="handleCurrentChange"
                  @handleSizeChange="handleSizeChange"
                />
              </div>
            </div>

            <!-- /.頁碼 -->
          </div>
          <!-- /.文章列表 -->
        </div>
        <div class="col-lg-3 pt-4">
          <!-- 廣告 -->
          <div class="section-group">
            <div class="row">
              <div class="col-12">
                <N2Vue></N2Vue>
              </div>
            </div>
          </div>
          <!-- ./廣告 -->

          <!-- 編輯推薦 -->
          <div class="featured-article section-group">
            <h2 class="side-title">{{ $t('Topic.articlelist.title') }}</h2>
            <div class="card px-3">
              <ul class="rank-list">
                <li
                  v-for="(recommon, index) in recommonlist"
                  v-bind:key="recommon.id"
                >
                  <div class="rank-no py-3">{{ index + 1 }}</div>
                  <div class="rank-title py-3 pl-3">
                    <router-link
                      v-bind:to="{
                        name: 'articleview',
                        query: {
                          id: recommon.id,
                        },
                      }"
                    >
                      {{ recommon.sgL_Title }}</router-link
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!-- /.編輯推薦 -->

          <!-- 熱門話題 -->
          <div class="hot-article section-group">
            <h2 class="side-title">{{ $t('Topic.articlelist.HotList') }}</h2>
            <div class="card px-3">
              <ul class="rank-list">
                <li v-for="(hot, index) in HotList" :key="hot.id">
                  <div class="rank-no py-3">{{ index + 1 }}</div>
                  <div class="rank-title p-3 pl-3">
                    <router-link
                      v-bind:to="{
                        name: 'articleview',
                        query: {
                          id: hot.id,
                        },
                      }"
                    >
                      {{ hot.sgL_Title }}</router-link
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!-- /.熱門話題 -->
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import bases from "../../api/httpApi/base";
import N2Vue from "../Ad/N2.vue";
import pagination from "../common/Page2";

export default {
  data() {
    return {
      base: null,
      //话题类型list
      topicTypeId: 9999,
      floading: true,
      HotList: null,
      recommonlist: null,
      topicTypeList: null,
      //话题List
      topicList: null,
      //分页参数
      pageParams: {
        currentPage: 1,
        limit: 12,
        total: 0,
        pageshow: false,
        pageSizes: [5, 10, 12, 20, 30, 40, 50, 60, 80, 100],
      },
    };
  },
  watch: {
    // topicTypeId(newvalue, oldvalue) {
    //   this.$router.push({
    //     path: this.$route.path,
    //     query: {
    //       page: this.pageParams.currentPage,
    //       size: this.pageParams.limit,
    //       TypeId: newvalue,
    //     },
    //   });
    // },
  },
  components: {
    pagination: pagination,
    N2Vue,
  },
  created() {
    this.base = bases;
    this.$store.dispatch("updateCurrentIndex", 10);
    this.GetTopicList();
    this.getTopicTypeList();
    this.GetTopicRecommonList();
    this.getHotList();
  },
  methods: {
    GetUrlParam() {
      let page = parseInt(this.$route.query.page);
      if (!page || page <= 0) {
        page = this.pageParams.currentPage;
      }
      this.pageParams.currentPage = page;
      let size = parseInt(this.$route.query.size);
      if (this.pageParams.pageSizes.indexOf(size) === -1) {
        size = this.pageParams.limit;
      }
      this.pageParams.limit = size;
      let typeId = parseInt(this.$route.query.TypeId);
      if (typeId != undefined) {
        this.topicTypeId = typeId;
      }
    },
    GetTopicList() {
      this.GetUrlParam();
      let topicTypeId = this.topicTypeId;
      if (this.topicTypeId == 0) {
        topicTypeId = null;
      }
      let params = {
        SGL_MasterSort: topicTypeId,
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit,
        MaxResultCount: this.pageParams.limit,
      };
      this.$api.TopicApi.GetArticleListDesk(params).then((res) => {
        if (res.data.success) {
          this.floading = false;
          this.topicList = res.data.result.items;
          this.pageParams.total = res.data.result.totalCount;
          if (this.pageParams.total > 1) {
            this.pageParams.pageshow = true;
          }
        }
      });
    },
    getHotList() {
      let params = {
        Sorting: "QueriesCount",
        MaxResultCount: 10,
      };
      this.$api.TopicApi.GetArticleListDesk(params).then((res) => {
        if (res.data.success) {
          this.HotList = res.data.result.items;
        }
      });
    },
    GetTopicRecommonList() {
      let params = {
        SGL_Recommend: true,
        Sorting: "DiyCount",
        MaxResultCount: 10,
      };
      this.$api.TopicApi.GetArticleListDesk(params).then((res) => {
        if (res.data.success) {
          this.recommonlist = res.data.result.items;
        }
      });
    },

    //根据类型查询列表
    GetListByType(id) {
      this.$router.push({
        path: this.$route.path,
        query: {
          page: 1,
          size: this.pageParams.limit,
          TypeId: id,
        },
      });

      // if (id == 0) {
      //   this.topicTypeId = null;
      //   this.GetTopicList();
      // } else {
      //   this.topicTypeId = id;
      // }
    },
    getTopicTypeList() {
      let params = {
        SGL_TypeT: 10, //文章類型
      };
      this.$api.TopicApi.GetArticleTypeDesk(params).then((res) => {
        if (res.data.success) {
          this.topicTypeList = res.data.result.items;
        }
      });
    },
    //分页的方法
    handleCurrentChange(val) {
      this.pageParams.currentPage = val;
      this.GetTopicList();
    },
    handleSizeChange(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.GetTopicList();
    },
    go() {
      this.$router.go(0);
    },
  },
  computed: {
    getPageShow() {
      return this.pageParams.pageshow;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Topic/articleList.vue